module.exports = __webpack_public_path__ + "img/hl6.bd93eb51.png";